/*
 * File: /src/router/routes/dashboard.js
 * Created Date: Thursday August 12th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 12th August 2021 10:22:25 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
const DashboardPane = () =>
  import(
    /* webpackChunkName: "Inbox" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue'
  );

export const dashboardRoutes = [
  {
    path: 'dashboard',
    name: 'Dashboard',
    component: DashboardPane
  }
];
